export default "__VITE_ASSET__DATcf22b__"